<template>
  <div class="back-head-box">
    <!-- <Icon type="md-arrow-back" @click="back" /> -->
    <div></div>
    <div class="right" @click="setLange">{{ $store.state.languageName }}</div>
  </div>
</template>

<script>
const noop = () => { }; // 定义一个空函数
noop(); // 调用它不做任何事情
export default {
  name: 'backHead',
  props: {},
  methods: {
    back() {
      this.$router.go(-1)
    },
    setLange() {
      this.$store.commit('changeIsShow', true);
    }
  }
}
</script>
<style scoped lang="scss">
.back-head-box {
  height: 50px;
  // width: 600px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  margin-bottom: 20px;

  .right {
    font-size: 14px;
  }
}
</style>
